export const CONSTANTS = {
  WELCOME_MSG: "welcome_msg",
  COMPONENT_LIST_MSG: "component_list_msg",
  DEFAULT_MSG: "default_msg",
  PROFILE_MSG: "profile_msg",
  SETTINGS: "settings",
  PROFILE: "profile",
  LOGOUT: "logout",
  THEME: "theme",
  SXP_TITLE: "Welcome to TSF React base project",
  SXP_SUBTITLE: "Service eXperience Platform",
  SXP_DEFAULT_MSG: "Hi, Welcome To React Template Project",
  VERSION_ID: "WORKING",
  COULDNT_UPLOAD_DOC: "Could not upload Document",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  BUSINESS_USER: "business-user",
  SELECT_START_END_DATE: "Select start date and end date",
  USER_EMAIL: "user-email",
  FIRST_NAME: "first-name",
  LAST_NAME: "last-name",
  USER_ID: "user-id",
  REACT_TOKEN: "react-token",
  USER_TYPE: "user-type",
  COUNTRY: "country",
  I18NEXTLNG: "i18nextLng",
  REALM: "medunited",
  CLIENT_ID: "medunited",
  AUTH_SERVER_URL: process.env.REACT_APP_AUTH_SERVER_URL,
};

export const EXPLORE_FILES = {
  TITLE: "Explore Files",
  ADD_FILE: "Add File",
  FILE_NAME: "File Name",
  DOMAIN: "Domain",
  SUBDOMAIN: "Subdomain",
  VERSION: "Version",
  ACTIONS: "Actions",
  PREVIEW: "Preview",
  DELETE: "Delete",
  DIALOG_TITLE: "Preview Document",
  CANCEL: "Cancel",
  QUERY_UPDATED: "Query updated successfully",
  FETCH_ERROR: "Failed to fetch documents:",
  UPDATE_ERROR: "Failed to update query",
  DELETE_ERROR: "Delete failed:",
  FETCH_PREVIEW_ERROR: "Failed to fetch the file preview",
  DELETE_CONFIRMATION: "Error deleting file:",
  LOADING_MESSAGE: "Loading...",
  ERROR: "error",
  SUCCESS: "success",
  FILE_DELETED: "File deleted successfully!",
  PDF_PREVIEW: "PDF Preview",
  FILE_DELETE_FAIL: "Failed to delete file!",
  FILE_LOAD_FAIL: "Failed to load files.Please try again later.",
  NO_FILES_TEXT: "No Files are uploaded",
  DOCUMENT_PREVIEW: "Document Preview",
  CLOSE: "Close",
  SUBMIT: "Submit",
  name: "name",
  domains: "domain",
  subdomain: "subdomain",
  version: "version",
  clientSide: "clientSide",
};

export const FILE_UPLOAD_CONSTANTS = {
  TITLE: "File Upload and Download",
  UPLOAD_BUTTON: "Upload File",
  UPLOAD_AGAIN_BUTTON: "Upload Again",
  UPLOADED_FILE: "Uploaded File:",
  DOMAIN_LABEL: "Domain",
  SUBDOMAIN_LABEL: "Subdomain",
  COURSE_NAME_LABEL: "Course Name",
  SUBMIT_BUTTON: "Submit",
  UPLOAD_SUCCESS: "File uploaded successfully!",
  UPLOAD_ERROR: "Error uploading file. Please try again.",
  DOWNLOAD_ERROR: "Error downloading file. Please try again.",
  SUCCESS: "success",
  ERROR: "error",
  BOTTOM: "bottom",
  CENTER: "center",
  DOMAIN_DEFAULT_TEXT: "MOI",
  REPLACE_FILE: "Replace File",
};

export const HOME_CONSTANTS = {
  WELCOME_MESSAGE: "Welcome to Techsophy Document Digitisation",
  WELCOME_DETAILED_MESSAGE:
    "Upload and get details of your document effortlessly",
};

export const HEADER = {
  PROFILE: "Profile",
  LOGOUT: "Logout",
};

export const EMAILS_CONSTANTS = {
  QUERY: "Query",
  RESPONSE: "Response",
  sendMailText: "Send Email",
};

export interface SnackbarInterface {
  open: boolean;
  message: string;
  severity: "success" | "error";
}
